import React, { useState, forwardRef, useImperativeHandle } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Reusable Dialog Component
const CustomDialog = forwardRef(({ title, children, onConfirm }, ref) => {
    const [open, setOpen] = useState(false);

    // Expose handleOpen and handleClose to parent
    useImperativeHandle(ref, () => ({
        handleOpen: () => setOpen(true),
        handleClose: () => setOpen(false),
    }));

    const handleClose = () => setOpen(false);

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ m: 0, p: 2 }}>
                {title}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>{children}</DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button
                    onClick={() => {
                        if (onConfirm) onConfirm();

                        handleClose();
                    }}
                    variant="contained"
                >
                    Copy To Clipboard
                </Button>
            </DialogActions>
        </Dialog>
    );
});

export default CustomDialog;
